module.exports = __webpack_public_path__ + "static/media/toolbar-drag.ac53214e.svg";